import type { GetStaticPaths, GetStaticProps } from 'next';

import { CatchAllPage } from '~/layouts/catch-all-page';
import { getCatchallProps } from '~/utils/get-catchall-props';
import { getPlasmicPaths } from '~/utils/plasmic/get-plasmic-paths';

export default CatchAllPage;

export const getStaticProps: GetStaticProps = async (context) => {
  const { catchall } = context.params ?? {};
  const locale = context.locale || 'en-US';

  const path = typeof catchall === 'string' ? catchall : Array.isArray(catchall) ? `/${catchall.join('/')}` : '/';

  return {
    props: await getCatchallProps(path, locale),
    revalidate: process.env.NODE_ENV === 'development' ? 10 : undefined,
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const plasmicPaths = await getPlasmicPaths();
  const paths = plasmicPaths.reduce<{ params: { catchall: string[] } }[]>((acc, path) => {
    if (!/\/articles\//.test(path)) {
      acc.push({
        params: {
          catchall: path.substring(1).split('/'),
        },
      });
    }

    return acc;
  }, []);

  return {
    paths,
    fallback: 'blocking',
  };
};
